import {adUnitApi} from 'common/api/entitiesApi'
import {OwnedEntitySelector} from 'common/components/reloadable/OwnedEntitySelector'

export interface Props {
    publisherId?: number
    value?: number
    onChange?: (value?: number) => void
    style?: React.CSSProperties
    disabled?: boolean
    placeholder?: string
    multiple?: boolean
}

export const AdUnitSelector = ({publisherId, value, onChange, style, disabled, placeholder, multiple}: Props) => {

    function loadEntity(id: number) {
        return adUnitApi.adUnitSelector(id)
    }

    function searchEntities(search: string, size: number, page: number, pubId?:number) {
        return adUnitApi.adUnitSelectorPage('name', 'asc', search, {query: {size, page}})
    }

    return <OwnedEntitySelector
        ownerId={publisherId}
        value={value}
        onChange={onChange}
        loadEntity={loadEntity}
        searchEntities={searchEntities}
        placeholder={placeholder}
        disabled={disabled}
        style={style}
        multiple={multiple}
        errorText="Can't load Ad Units"
    />
}